import React from 'react';

import { VpHookFormCheckbox } from '../../';
import { useFetchPluginById } from '../../../hooks';

export const VpPluginDateSubmittedCheckbox = () => {
  const { data } = useFetchPluginById();

  return (
    <VpHookFormCheckbox
      name="showSubmissionDate"
      label="Date Submitted"
      defaultValue={data?.styles?.showSubmissionDate}
    />
  );
};

export default VpPluginDateSubmittedCheckbox;



// WEBPACK FOOTER //
// ./src/vp-ui/form-fields/plugin-details/VpPluginDateSubmittedCheckbox.jsx